// extracted by mini-css-extract-plugin
export default {"recommendations_wrapper":"Recommendations_recommendations_wrapper__fGgkq","recommendations":"Recommendations_recommendations__Lj4ZZ"};